






























































import Vue from "vue";
import { Component } from "vue-property-decorator";
import store from "../core/store";

@Component({
  components: {},
})
export default class TmDetails extends Vue {
  get cipoURL() {
    var url = "https://www.ic.gc.ca/app/opic-cipo/trdmrks/srch/";
    var tmid = this.tmDetails!.applicationNumber;
    if (tmid) {
      url = url
        .concat("viewTrademark?id=")
        .concat(tmid)
        .concat("&lang=eng&tab=reg");
    }
    return url;
  }

  get usptoURL() {
    var url = "http://tsdr.uspto.gov/";
    var tmid = this.tmDetails!.applicationNumber;
    if (tmid) {
      url = url
        .concat("#caseNumber=")
        .concat(tmid)
        .concat("&caseType=SERIAL_NO&searchType=statusSearch");
    }
    return url;
  }

  get tmDetails() {
    if (store.state.matchResult === null) {
      return null;
    } else {
      return store.state.matchResult.queryTrademark;
    }
  }

  get hasBothTypes() {
    if (this.tmDetails) {
      const ft = this.tmDetails.gsFormat.filter((x) => x.type === "freetext");
      const pl = this.tmDetails.gsFormat.filter((x) => x.type === "picklist");
      return ft.length > 0 && pl.length > 0;
    }
    return false;
  }

  get showType() {
    return store.state.displayedTextType;
  }

  toggle(texttype: string) {
    store.toggleDisplayTextType(texttype);
  }
}
